import styled from 'styled-components'

const ScrollContainer = styled.div`
  display: grid;
  min-height: 0;
  overflow-y: auto;
  grid-auto-rows: min-content;
`

export default ScrollContainer
